import React from "react";
import whatsappIcon from "../../assets/images/icons/whatsapp.svg"; // Ajuste o caminho conforme necessário
import "./FloatingWhatsAppButton.scss";
import { handleClickSchedule } from "Helper";

const WhatsAppButton: React.FC = () => {
  return (
    <div className="whatsapp-container">
      <img
        id="whatsapp-contact-float"
        src={whatsappIcon}
        alt="Enviar mensagem por WhatsApp"
        className="whatsapp-icon"
        onClick={handleClickSchedule}
      />
    </div>
  );
};

export default WhatsAppButton;
